import React, { useEffect, useRef, useState } from "react";
import ComponentTitle from "../../../Common/ComponentTitle";
import { LoadScriptNext, Autocomplete } from "@react-google-maps/api";
import {
  Button,
  Card,
  Checkbox,
  Col,
  Divider,
  Form,
  Image,
  Input,
  InputNumber,
  message,
  Row,
  Select,
  Upload,
} from "antd";
import {
  DeleteOutlined,
  DownOutlined,
  MinusCircleOutlined,
  MinusSquareFilled,
  PlusOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import {
  addPlot,
  addProperty,
  deleteImageAPI,
  editPlot,
  editProperty,
  getPropertiesbyId,
  getPropertyTypeDetails,
  uploadfloorPlanImageAPI,
  uploadImageAPI,
  uploadThumbnailAPI,
} from "./PropertiesapiFunctions";
import { useLocation, useNavigate } from "react-router-dom";
import { getCategoryDetails } from "../CategoryDetails/CategoryapiFunctions";
import { MdUpload } from "react-icons/md";
import { getAmenityDetails } from "../Amenities/AmenitiesapiFunctions";
import ReactQuill from "react-quill";
import { getCity, getstate } from "../StateCity/StateCityApi";
import { youtubePattern } from "../../../utils";

function CreateProperty() {
  const [form] = Form.useForm();
  const formRef = useRef(form);
  const MAX_FILE_SIZE_MB = 1000;
  const location = useLocation();
  const record = location.state?.record;
  const from = location.state?.from;
  const [fileLists, setFileList] = useState([]);
  const [selectedPropertyTypes, setSelectedPropertyTypes] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [propertyData, setPropertyData] = useState({});
  const [slug, setSlug] = useState("");
  const [title, setTitle] = useState("");
  const [categoryData, setCategoryData] = useState([]);
  const [updatedList, setUpdatedList] = useState([]);
  const [stateData, setStateData] = useState([]);
  const [cityData, setCityData] = useState([]);
  const [subCategoryData, setSubCategoryData] = useState([]);
  const [amenitiesData, setAmenitiesData] = useState([]);
  const [propertyTypeData, setPropertyTypeData] = useState([]);
  const navigate = useNavigate();
  const [selectedThumbnail, setSelectedThumbnail] = useState(null);
  const [selectedAmenities, setSelectedAmenities] = useState([]);
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [propertylocation, setLocation] = useState("");
  const [isPlot, setIsplot] = useState(null);
  const [isHotel, setIsHotel] = useState(null);
  const [isOffice, setIsOffice] = useState(null);
  const [isWarehouse, setIsWareHouse] = useState(null);
  const { Option } = Select;
  const options = [];
  // for (let i = 10; i < 36; i++) {
  //   options.push({
  //     value: i.toString(36) + i,
  //     label: i.toString(36) + i,
  //   });
  // }
  const handleChange = (value) => {
    console.log(`Selected: ${value}`);
  };
  const [size, setSize] = useState("middle");
  const handleSizeChange = (e) => {
    setSize(e.target.value);
  };
  const [floorPlanImages, setFloorPlanImages] = useState({});
  const [brochure, setBrochure] = useState(record?.brochurePath ?? null);
  const autocompleteRef = useRef(null);
  const [rentType, setRentType] = useState(
    from === "edit"
      ? record?.propertyTypeMappings.map((i, id) => {
          return i.propertyType.typeName === "Rent" ? true : false;
        })
      : []
  );
  const [leaseType, setLeaseType] = useState(
    from === "edit"
      ? record?.propertyTypeMappings.map((i, id) => {
          return i.propertyType.typeName === "Lease" ? true : false;
        })
      : []
  );
  const GOOGLE_MAPS_API_KEY = "AIzaSyCLDXwDI19neQ_CZPWsuYRegL4QZxqyJsk";
  const libraries = ["places"];
  const ownershipOptions = ["Freehold", "Leasehold", "Cooperative Society"];
  const generateSlug = (value) => {
    return value
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9\s-]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");
  };
  const gridStyle = {
    width: "15.5%",
    textAlign: "left",
  };
  const handleTitleChange = (e) => {
    const inputValue = e.target.value;
    const slugValue = generateSlug(inputValue);
    form.setFieldsValue({
      slug: slugValue,
    });

    setTitle(inputValue);
    setSlug(slugValue);
  };

  const staticPropertyTypes = [
    "1BHK",
    "2BHK",
    "3BHK",
    "4BHK",
    "5BHK",
    "6BHK",
    "7BHK",
    "8BHK",
    "9BHK",
    "10BHK",
  ];

  function FetchPropertiesById() {
    setIsLoading(true);
    getPropertiesbyId(`${record.id}`)
      .then((response) => {
        if (response.status) {
          setPropertyData(response.data?.data?.propertyData);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.log("error", err);
        setIsLoading(false);
      });
  }

  useEffect(() => {
    if (from === "edit" && propertyData?.images) {
      const initialFileList = propertyData.images?.map((image, index) => ({
        uid: index,
        name: image.imageName,
        status: "done",
        id: image.id,
        url: `${process.env.REACT_APP_IMAGE_URL}${image.imagePath}`,
        thumbnailPath: image.thumbnailPath,
        thumbnailName: image.thumbnailName,
      }));
      setFileList(initialFileList);

      const preselectedThumbnail = initialFileList.find(
        (file) => file.thumbnailPath
      );
      if (preselectedThumbnail) {
        setSelectedThumbnail(preselectedThumbnail.uid);
      }
    }
  }, [from, propertyData]);

  const createProperty = (changedValues) => {
    console.log(changedValues);
    let formData = new FormData();
    updatedList.forEach((file, index) => {
      formData.append("files", file);
    });
    formData.append("brochure", brochure);
    formData.append("categoryId", changedValues.categoryId);
    formData.append("subCategoryId", changedValues.subCategoryId);
    formData.append("description", changedValues.description);

    const floortypeformdata = (changedValues.floorPlanType || []).map(
      (item, index) => ({
        title: item.title,
        area: item.area,
        floorPlanid: floorPlanImages?.[index]?.[0]?.id || null,
      })
    );

    formData.append("floorPlanType", JSON.stringify(floortypeformdata));
    formData.append("propertyType", JSON.stringify(changedValues.propertyType));
    formData.append("title", changedValues.title);
    formData.append("slug", changedValues.slug);
    formData.append("price", changedValues.price);
    formData.append("location", changedValues.location);
    formData.append("listedBy", changedValues.listedBy);
    formData.append("carpetArea", changedValues.carpetArea);
    formData.append("developerName", changedValues.developerName);
    formData.append("isNegotiable", changedValues.isNegotiable);
    formData.append("propertyAge", changedValues.propertyAge);
    formData.append("priceIn", changedValues.priceIn);
    formData.append("reraId", changedValues.reraId);
    formData.append("projectName", changedValues.projectName);
    formData.append("zipCode", changedValues.zipCode);
    formData.append("state", changedValues.state);
    formData.append("city", changedValues.city);
    formData.append("amenities", JSON.stringify(changedValues.amenities));
    formData.append(
      "nearbyLandmarks",
      JSON.stringify(changedValues.nearbyLandmarks)
    );

    formData.append("availabiltyStatus", changedValues.availabiltyStatus);
    formData.append("youtubeUrl", changedValues.youtubeUrl);
    formData.append("isLuxeriousProperty", changedValues.isLuxeriousProperty);
    formData.append("longitude", Number(longitude));
    formData.append("latitude", Number(latitude));

    const newFloorPlans = (changedValues.floorPlanType || []).map(
      (item, index) => {
        const existingPlan =
          propertyData?.floorPlans?.find(
            (plan) => plan.title === item.title && plan.type === item.type
          ) || {};

        return {
          title: item.title,
          area: item.area,
          floorPlanid:
            existingPlan.id ||
            (Array.isArray(floorPlanImages)
              ? floorPlanImages?.[index]?.id
              : null) ||
            (Array.isArray(floorPlanImages?.[index])
              ? floorPlanImages?.[index]?.[0]?.id
              : null) ||
            null,
        };
      }
    );
    if (isHotel) {
      formData.append("parking", changedValues.parking);
      formData.append("totalRooms", changedValues.totalRooms);
      formData.append("totalFloors", changedValues.totalFloors);
      formData.append("licenses", JSON.stringify(changedValues.licenses));
      formData.append(
        "numberOfBanquetHalls",
        changedValues.numberOfBanquetHalls
      );
      formData.append("hotelCategory", changedValues.hotelCategory);
      formData.append("parkingAvailability", changedValues.parkingAvailability);
      formData.append("airConditioning", changedValues.airConditioning);
    }
    if (isOffice) {
      formData.append("parking", changedValues.parking);
      formData.append("parkingAvailability", changedValues.parkingAvailability);
      formData.append("airConditioning", changedValues.airConditioning);
      formData.append("buildingType", changedValues.buildingType);
    }
    if (isWarehouse) {
      formData.append("clearHeight", changedValues.clearHeight);
      formData.append("dockingBays", changedValues.dockingBays);
      formData.append("warehouseType", changedValues.warehouseType);

      formData.append("parkingAvailability", changedValues.parkingAvailability);
      formData.append("floorType", changedValues.floorType);
      formData.append("security", changedValues.security);
      formData.append("fireSafetyEquipment", changedValues.fireSafetyEquipment);
    }
    if (!isHotel && !isOffice && !isWarehouse && !isPlot) {
      formData.append("bedrooms", changedValues.bedrooms);
      formData.append("bathrooms", changedValues.bathrooms);
      formData.append("floorNo", changedValues.floorNo);
      formData.append("balconies", changedValues.balconies);
      formData.append("totalFloors", changedValues.totalFloors);
      formData.append(
        "priceType",
        JSON.stringify(changedValues.priceType || [])
      );

      formData.append("furnishing", changedValues.furnishing);
      formData.append("plotArea", changedValues.plotArea);
      formData.append("parking", changedValues.parking);
    }

    if (rentType.includes(true)) {
      formData.append("rentPrice", Number(changedValues.rentPrice));
    }
    if (leaseType.includes(true)) {
      formData.append("leaseType", changedValues.leaseType);
    }
    const floortypePayload = [...newFloorPlans];
    const payload = {
      propertyId: record.id,
      title: changedValues.title,
      slug: changedValues.slug,
      developerName: changedValues.developerName,
      reraId: changedValues.reraId,
      isNegotiable: changedValues.isNegotiable,
      priceIn: changedValues.priceIn,
      nearbyLandmarks: changedValues.nearbyLandmarks,
      propertyAge: changedValues.propertyAge,
      description: changedValues.description,
      location: propertylocation,
      longitude: Number(longitude),
      latitude: Number(latitude),
      price: changedValues.price,
      priceType: changedValues.priceType,
      propertyType: selectedPropertyTypes,
      listedBy: changedValues.listedBy,
      carpetArea: changedValues.carpetArea,
      plotArea: changedValues.plotArea,
      furnishing: changedValues.furnishing,
      parking: changedValues.parking,
      parkingAvailability: changedValues.parkingAvailability,
      totalFloors: changedValues.totalFloors,
      floorNo: changedValues.floorNo,
      floorPlanType: floortypePayload,
      projectName: changedValues.projectName,
      zipCode: changedValues.zipCode,
      city: changedValues.city,
      state: changedValues.state,
      balconies: changedValues.balconies,
      bathrooms: changedValues.bathrooms,
      bedrooms: changedValues.bedrooms,
      availabiltyStatus: changedValues.availabiltyStatus,
      amenities: selectedAmenities,
      youtubeUrl: changedValues.youtubeUrl,
      isLuxeriousProperty: changedValues.isLuxeriousProperty,

      ...(rentType.includes(true) && {
        rentPrice: Number(changedValues.rentPrice),
      }),

      ...(leaseType.includes(true) && {
        leaseType: changedValues.leaseType,
      }),

      ...(isHotel && {
        totalRooms: changedValues.totalRooms,
        licenses: changedValues.licenses,
        numberOfBanquetHalls: changedValues.numberOfBanquetHalls,
        hotelCategory: changedValues.hotelCategory,
        airConditioning: changedValues.airConditioning,
      }),

      ...(isOffice && {
        buildingType: changedValues.buildingType,
        airConditioning: changedValues.airConditioning,
      }),

      ...(isWarehouse && {
        clearHeight: changedValues.clearHeight,
        dockingBays: changedValues.dockingBays,
        warehouseType: changedValues.warehouseType,
        floorType: changedValues.floorType,
        security: changedValues.security,
        fireSafetyEquipment: changedValues.fireSafetyEquipment,
      }),
    };

    {
      from === "add"
        ? addProperty(formData)
            .then((response) => {
              if (response.data.status) {
                message.success({ content: response.data.message });
                navigate("/propertiesDetails");
              } else {
                message.error({ content: response.data.message });
              }
            })
            .catch((error) => {
              console.log(error);
            })
        : editProperty(payload)
            .then((response) => {
              if (response.data.status) {
                message.success({ content: response.data.message });
                navigate("/propertiesDetails");
              }
            })
            .catch((error) => {
              console.log(error);
            });
    }
  };

  const createPlot = (changedValues) => {
    console.log(changedValues, "test");
    let formData = new FormData();
    fileLists.forEach((file, index) => {
      formData.append(`files`, file);
    });
    formData.append("categoryId", changedValues.categoryId);
    formData.append("subCategoryId", changedValues.subCategoryId);
    formData.append("description", changedValues.description);
    formData.append("title", changedValues.title);
    formData.append("slug", changedValues.slug);
    formData.append("developerName", changedValues.developerName);
    formData.append("isNegotiable", changedValues.isNegotiable);
    // formData.append("propertyAge", changedValues.propertyAge);
    formData.append("priceIn", changedValues.priceIn);
    formData.append("reraId", changedValues.reraId);
    formData.append("propertyType", changedValues.propertyType);
    formData.append("price", changedValues.price);
    formData.append("location", propertylocation);
    formData.append("listedBy", changedValues.listedBy);
    formData.append("boundaryWall", changedValues.boundaryWall);
    formData.append("mainEntranceFacing", changedValues.mainEntranceFacing);
    formData.append("projectName", changedValues.projectName);
    formData.append("gatedCommunity", changedValues.gatedCommunity);
    formData.append("openSides", changedValues.openSides);
    formData.append("widthRoadFacing", Number(changedValues.widthRoadFacing));
    formData.append("zipCode", changedValues.zipCode);
    formData.append("amenities", JSON.stringify(changedValues.amenities));
    formData.append("state", changedValues.state);
    formData.append("city", changedValues.city);
    formData.append(
      "nearbyLandmarks",
      JSON.stringify(changedValues.nearbyLandmarks)
    );
    formData.append("ownershipType", changedValues.ownershipType);
    formData.append("plotArea", changedValues.plotArea);
    formData.append("waterSupply", changedValues.waterSupply);
    formData.append("governmentApproval", changedValues.governmentApproval);
    formData.append("landUseCertificate", changedValues.landUseCertificate);
    formData.append("youtubeUrl", changedValues.youtubeUrl);
    formData.append("isLuxeriousProperty", changedValues.isLuxeriousProperty);
    formData.append("longitude", Number(longitude));
    formData.append("latitude", Number(latitude));

    const floortypeformdata = (changedValues.floorPlanType || []).map(
      (item, index) => ({
        title: item.title,
        area: item.area,
        floorPlanid: floorPlanImages?.[index]?.[0]?.id || null,
      })
    );

    formData.append("floorPlanType", JSON.stringify(floortypeformdata));
    const newFloorPlans = (changedValues.floorPlanType || [])?.map(
      (item, index) => {
        const existingPlan =
          propertyData?.floorPlans?.find(
            (plan) => plan.title === item.title && plan.type === item.type
          ) || {};

        return {
          title: item.title,
          area: item.area,
          floorPlanid:
            existingPlan.id ||
            (Array.isArray(floorPlanImages)
              ? floorPlanImages?.[index]?.id
              : null) ||
            (Array.isArray(floorPlanImages?.[index])
              ? floorPlanImages?.[index]?.[0]?.id
              : null) ||
            null,
        };
      }
    );

    const floortypePayload = [...newFloorPlans];
    const payload = {
      propertyId: record.id,

      title: changedValues.title,
      slug: changedValues.slug,
      developerName: changedValues.developerName,
      projectName: changedValues.projectName,
      categoryId: changedValues.categoryId,
      propertyType: changedValues.propertyType,
      subCategoryId: changedValues.subCategoryId,
      location: propertylocation,
      zipCode: changedValues.zipCode,
      state: changedValues.state,
      city: changedValues.city,
      longitude: Number(longitude),
      latitude: Number(latitude),
      price: changedValues.price,
      priceIn: changedValues.priceIn,
      reraId: changedValues.reraId,
      listedBy: changedValues.listedBy,
      isLuxeriousProperty: changedValues.isLuxeriousProperty,
      isNegotiable: changedValues.isNegotiable,
      boundaryWall: changedValues.boundaryWall,
      gatedCommunity: changedValues.gatedCommunity,
      governmentApproval: changedValues.governmentApproval,
      landUseCertificate: changedValues.landUseCertificate,
      mainEntranceFacing: changedValues.mainEntranceFacing,
      ownershipType: changedValues.ownershipType,
      waterSupply: changedValues.waterSupply,
      plotArea: changedValues.plotArea,
      openSides: changedValues.openSides,
      widthRoadFacing: Number(changedValues.widthRoadFacing),
      youtubeUrl: changedValues.youtubeUrl,
      nearbyLandmarks: changedValues.nearbyLandmarks,
      description: changedValues.description,
      floorPlanType: floortypePayload,
      amenities: selectedAmenities,
    };
    {
      from === "add"
        ? addPlot(formData)
            .then((response) => {
              if (response.data.success) {
                message.success({ content: response.data.message });
              }
              navigate("/propertiesDetails");
            })
            .catch((error) => {
              console.log(error);
            })
        : editPlot(payload)
            .then((response) => {
              if (response.data.success) {
                message.success({ content: response.data.message });
              }

              navigate("/propertiesDetails");
            })
            .catch((error) => {
              console.log(error);
            });
    }
  };

  const beforeUpload = (file) => {
    const isPDF = file.type === "application/pdf";
    if (!isPDF) {
      message.error("Only PDF files are allowed!");
      return Upload.LIST_IGNORE;
    }

    const isLt25M = file.size / 1024 / 1024 < MAX_FILE_SIZE_MB;
    if (!isLt25M) {
      message.error(`File must be smaller than ${MAX_FILE_SIZE_MB}MB!`);
      return Upload.LIST_IGNORE;
    }

    return true;
  };

  const handleUploadChange = ({ file }) => {
    if (file.status === "done" || file.status === "success") {
      setBrochure(file.originFileObj);
    } else if (file.status === "removed") {
      setBrochure(null);
    }
  };

  const handleRemoveBrochure = () => {
    setBrochure(null);
  };

  const customRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess("ok");
      setBrochure(file);
    }, 1000);
  };
  const props = {
    name: "file",
    accept: ".jpg,.jpeg,.png,.pdf",
    multiple: true,
    beforeUpload: (file) => {
      const isLt25M = file.size / 1024 / 1024 < MAX_FILE_SIZE_MB;
      if (!isLt25M) {
        message.error(`File must be smaller than ${MAX_FILE_SIZE_MB}MB!`);
        return false;
      }

      if (fileLists.length >= 15) {
        message.error("You can only upload up to 15 files at a time!");
        return false;
      }

      if (from === "edit") {
        const formData = new FormData();
        formData.append("image", file);
        formData.append("propertyId", record.id);

        uploadImageAPI(formData)
          .then((response) => {
            if (response.data.status) {
              const image = response.data.data;
              const newImage = {
                uid: fileLists.length,
                name: image.imageName,
                status: "done",
                id: image.id,
                url: `${process.env.REACT_APP_IMAGE_URL}${image.imagePath}`,
                thumbnailPath: image.thumbnailPath || null,
                thumbnailName: image.thumbnailName || null,
              };

              setFileList((prevList) => [...prevList, newImage]);
              setUpdatedList((prevList) => [...prevList, newImage]);

              message.success("Image uploaded successfully");
            } else {
              message.error("Image upload failed");
            }
          })
          .catch((error) => {
            console.error("Error uploading image:", error);
            message.error("Image upload failed");
          });
        return false;
      }

      setUpdatedList((prevList) => [...prevList, file]);
      return false;
    },
  };

  const handleBeforeUpload = async (file, index) => {
    const formData = new FormData();
    formData.append("image", file);

    try {
      const response = await uploadfloorPlanImageAPI(formData);
      if (response.data.status) {
        const imageId = response.data.data.id;
        const imageName = response.data.data.imageName;
        const imagePath = response.data.data.imagePath;

        message.success(response.data.message);

        // Update the form field value
        const updatedList = [...form.getFieldValue("floorPlanType")];
        updatedList[index] = { ...updatedList[index], floorPlanid: imageId };
        form.setFieldsValue({ floorPlanType: updatedList });

        // Update state to display image
        setFloorPlanImages((prev) => ({
          ...prev,
          [index]: [
            {
              // uid:imageId,
              id: imageId, // Unique identifier
              name: imageName,
              status: "done",
              url: `${process.env.REACT_APP_IMAGE_URL}${imagePath}`, // Ensure full path
            },
          ],
        }));
      } else {
        message.error("Image upload failed");
      }
    } catch (error) {
      console.error("Error uploading image:", error);
      message.error("Image upload failed");
    }

    return false; // Prevent default upload behavior
  };

  const handleRemoveFloorPlan = (index) => {
    setFloorPlanImages((prev) => {
      const updatedImages = { ...prev };
      delete updatedImages[index]; // Remove the image from the state
      return updatedImages;
    });

    // Remove from form field as well
    const updatedList = [...form.getFieldValue("floorPlanType")];
    updatedList[index] = { ...updatedList[index], floorPlanid: null };
    form.setFieldsValue({ floorPlanType: updatedList });
  };

  const handleRemove = (file) => {
    if (file.id) {
      deleteImageAPI(`${file.id}`)
        .then((response) => {
          if (response.data.status) {
            setFileList((prevList) =>
              prevList.filter((item) => item.uid !== file.uid)
            );
            setUpdatedList((prevList) =>
              prevList.filter((item) => item.uid !== file.uid)
            );

            message.success("Image deleted successfully");
          } else {
            message.error("Failed to delete the image");
          }
        })
        .catch((error) => {
          console.error("Error deleting image:", error);
          message.error("Error occurred while deleting the image");
        });
    } else {
      setFileList((prevList) =>
        prevList.filter((item) => item.uid !== file.uid)
      );
      setUpdatedList((prevList) =>
        prevList.filter((item) => item.uid !== file.uid)
      );
    }
  };

  useEffect(() => {
    if (from === "edit" && propertyData) {
      const landmarksedit = Array.isArray(propertyData?.nearbyLandmarks)
        ? propertyData.nearbyLandmarks
        : JSON.parse(propertyData?.nearbyLandmarks || "[]");

      form.setFieldsValue({
        categoryId: propertyData.categoryId,
        subCategoryId: propertyData.subCategoryId,
        description: propertyData.description,
        title: propertyData.title,
        slug: propertyData.slug,
        developerName: propertyData?.developerName ?? "",
        propertyType:
          propertyData.propertyTypeMappings?.map(
            (i) => i.propertyType?.typeName
          ) || [],
        isNegotiable: propertyData.isNegotiable,
        parking: propertyData.parking,
        parkingAvailability: propertyData.parkingAvailability,
        leaseType: propertyData.leaseType,
        price: propertyData.price,
        rentPrice: propertyData.rentPrice,
        location: propertyData.location,
        listedBy: propertyData.listedBy,
        carpetArea: propertyData.carpetArea,
        carpetAreaUnit: propertyData.carpetAreaUnit,
        boundaryWall: propertyData.boundaryWall,
        gatedCommunity: propertyData.gatedCommunity,
        governmentApproval: propertyData.governmentApproval,
        landUseCertificate: propertyData.landUseCertificate,
        longitude: propertyData.longitude,
        latitude: propertyData.latitude,
        bedrooms: propertyData.bedrooms,
        plotArea: propertyData.plotArea,
        bathrooms: propertyData.bathrooms,
        balconies: propertyData.balconies,
        mainEntranceFacing: propertyData.mainEntranceFacing,
        priceIn: propertyData.priceIn,
        reraId: propertyData.reraId ?? "",
        projectName: propertyData.projectName ?? "",
        openSides: propertyData.openSides,
        widthRoadFacing: propertyData.widthRoadFacing,
        widthRoadFacingUnit: propertyData.widthRoadFacingUnit,
        zipCode: propertyData.zipCode,
        state: propertyData.state,
        city: propertyData.city,
        ownershipType: propertyData.ownershipType,
        plotArea: propertyData.plotArea,
        plotAreaUnit: propertyData.plotAreaUnit,
        waterSupply: propertyData.waterSupply,
        availabiltyStatus: propertyData.availabiltyStatus,
        floorNo: propertyData.floorNo,
        totalFloors: propertyData.totalFloors,
        dockingBays: propertyData.dockingBays,
        warehouseType: propertyData.warehouseType,
        floorType: propertyData.floorType,
        security: propertyData.security,
        clearHeight: propertyData.clearHeight,
        fireSafetyEquipment: propertyData.fireSafetyEquipment,
        isLuxeriousProperty: propertyData.isLuxeriousProperty,
        youtubeUrl: propertyData.youtubeUrl,
        furnishing: propertyData.furnishing,
        status: propertyData.status,
        buildingType: propertyData.buildingType,
        airConditioning: propertyData.airConditioning,
        propertyAge: propertyData.propertyAge,
        nearbyLandmarks: landmarksedit,
        totalRooms: propertyData.totalRooms,
        licenses: Array.isArray(propertyData?.licenses)
          ? propertyData.licenses
          : JSON.parse(propertyData?.licenses || "[]"),
        numberOfBanquetHalls: propertyData.numberOfBanquetHalls,
        hotelCategory: propertyData.hotelCategory,
        brochure: propertyData.brochurePath
          ? [
              {
                uid: 1,
                name: propertyData.brochureName,
                status: "done",
                url: `${process.env.REACT_APP_IMAGE_URL}${propertyData.brochurePath}`,
              },
            ]
          : [],

        priceType: Array.isArray(propertyData?.priceType)
          ? propertyData.priceType.map((i) => ({
              proprtyType: i.proprtyType,
              price: i.price,
              area: i.area,
            }))
          : JSON.parse(propertyData?.priceType || "[]"),
        floorPlanType: Array.isArray(propertyData?.floorPlans)
          ? propertyData.floorPlans.map((i) => ({
              title: i.title,
              id: i.id,
              floorPlanImagePath: i.floorPlanImagePath,
              area: i.area,
            }))
          : JSON.parse(propertyData?.floorPlans || "[]"),
        files:
          propertyData.images?.map((image, index) => ({
            uid: index,
            id: image.id,
            name: image.imageName,
            status: "done",
            url: `${process.env.REACT_APP_IMAGE_URL}${image.imagePath}`,
          })) || [],
        amenities: propertyData.amenities?.map((a) => a.id) || [],
      });
    }
  }, [propertyData]);

  function FetchAmenityDetails(currentPage) {
    getAmenityDetails(`limit=999`)
      .then((response) => {
        if (response.data.status) {
          setAmenitiesData(response.data?.data);
        }
      })
      .catch((err) => {
        console.log("error", err);
      });
  }

  function FetchPropertyTypeDetails(currentPage) {
    getPropertyTypeDetails(`?limit=999`)
      .then((response) => {
        if (response.data.status) {
          setPropertyTypeData(response.data?.data);
        }
      })
      .catch((err) => {
        console.log("error", err);
      });
  }
  function FetchCategoryDetails(parentId = "") {
    getCategoryDetails(`?categoryId=${record.categoryId ?? parentId}&limit=999`)
      .then((response) => {
        if (response.data.status) {
          if (record.categoryId || parentId) {
            const subCategories = response.data?.data[0]?.subCategories || [];
            setSubCategoryData(subCategories);

            const selectedSubCategory = subCategories.find(
              (i) => i.id === record.subCategoryId
            );
            setIsplot(selectedSubCategory ? selectedSubCategory.isPlot : null);
            setIsHotel(
              selectedSubCategory ? selectedSubCategory.isHotel : null
            );
            setIsWareHouse(
              selectedSubCategory ? selectedSubCategory.isWarehouse : null
            );
            setIsOffice(
              selectedSubCategory ? selectedSubCategory.isOffice : null
            );
          }

          if (categoryData.length === 0) {
            setCategoryData(response.data?.data || []);
          }
        }
      })
      .catch((err) => {
        console.log("error", err);
        return [];
      });
  }
  const handlePropertyTypeChange = (value, data) => {
    setRentType(
      data?.map((i, id) => {
        return i.label === "Rent" ? true : false;
      })
    );
    setLeaseType(
      data?.map((i, id) => {
        return i.label === "Lease" ? true : false;
      })
    );
    setSelectedPropertyTypes(value);
    form.setFieldsValue({ propertyType: value });
  };

  useEffect(() => {
    if (from === "edit" && record?.id) {
      FetchPropertiesById();
    }
  }, [from, record]);

  function handleCategoryChange(categoryId) {
    FetchCategoryDetails(categoryId);
    setSubCategoryData([]);
  }
  const handleSubCategoryChange = (value) => {
    const selectedSubCategory = subCategoryData.find((i) => i.id === value);
    if (selectedSubCategory) {
      setIsplot(selectedSubCategory.isPlot);
      setIsHotel(selectedSubCategory.isHotel);
      setIsOffice(selectedSubCategory.isOffice);
      setIsWareHouse(selectedSubCategory.isWarehouse);
    }
  };

  const handlePlaceSelect = () => {
    const place = autocompleteRef.current?.getPlace();

    if (!place || !place.address_components || !place.geometry) {
      console.warn("No address details available yet");
      return;
    }

    const addressComponents = place.address_components;
    let state = "";
    let city = "";
    let zipCode = "";

    addressComponents.forEach((component) => {
      const types = component.types;
      if (types.includes("administrative_area_level_1")) {
        state = component.long_name;
      }
      if (types.includes("locality")) {
        city = component.long_name;
      }
      if (types.includes("postal_code")) {
        zipCode = component.long_name || component.short_name;
      }
    });
    const geometry = place.geometry;
    let Latitude = geometry.location?.lat;
    let Longitude = geometry.location?.lng;

    form.setFieldsValue({
      location: place.formatted_address || "",
      state,
      city,
      zipCode,
    });
    setLatitude(Latitude);
    setLongitude(Longitude);
    // Optional: sync your state too
    setLocation(place.formatted_address || "");
  };

  const handleThumbnailChange = (file) => {
    if (from === "edit") {
      uploadThumbnailAPI(`${file.id}&propertyId=${record.id}`)
        .then((response) => {
          if (response.data.status) {
            setSelectedThumbnail(file.uid);
            message.success("Thumbnail uploaded successfully");
          } else {
            message.error("Thumbnail upload failed");
          }
        })
        .catch((error) => {
          console.error("Error uploading Thumbnail:", error);
          message.error("Thumbnail upload failed");
        });
    } else {
      setSelectedThumbnail(file.uid);
    }
  };
  function FetchState(stateId = "") {
    setIsLoading(true);
    getstate(`?limit=100`)
      .then((response) => {
        if (response.status) {
          if (stateId) {
            getCity(`limit=9999999`)
              .then((response) => {
                if (response.data.status) {
                  const expandedData = response.data?.data?.cities
                    .filter((item) => item.stateId === stateId)
                    ?.map((item) => ({
                      ...item,
                    }));

                  setCityData(expandedData || []);
                }
              })
              .catch((err) => {
                console.error("Error fetching cities", err);
              });
            setCityData(response.data?.data[0].cities || []);
          } else {
            setStateData(response?.data.data?.states);
          }
          setStateData(response?.data.data?.states);

          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.log("error", err);
        setIsLoading(false);
      });
  }

  useEffect(() => {
    FetchState();
    FetchCategoryDetails();
    FetchAmenityDetails();
    FetchPropertyTypeDetails();
  }, []);

  useEffect(() => {
    if (propertyData?.amenities) {
      const prefilledAmenities = propertyData.amenities.map((item) => item.id);
      setSelectedAmenities(prefilledAmenities);
      form.setFieldsValue({ amenities: prefilledAmenities });
    }
    if (propertyData?.propertyTypeMappings) {
      const prefilledPropertyType = propertyData?.propertyTypeMappings?.map(
        (item) => item.propertyType.id
      );
      setSelectedPropertyTypes(prefilledPropertyType);
      form.setFieldsValue({ propertyType: prefilledPropertyType });
    }
    if (propertyData?.location) {
      setLocation(propertyData.location);
      form.setFieldsValue({ location: propertyData.location });
    }
    if (propertyData?.latitude) {
      setLatitude(propertyData.latitude);
    }
    if (propertyData?.longitude) {
      setLongitude(propertyData.longitude);
    }
  }, [propertyData, form]);

  const handleAmenityChange = (value) => {
    setSelectedAmenities(value);
    form.setFieldsValue({ amenities: value });
  };

  return (
    <div>
      <ComponentTitle
        title={from === "edit" ? "Edit Property " : "Create Property Form"}
      />
      <div className="bg-white shadow-md shadow-slate-400 0px 20px 30px -10px">
        <Form
          className=" mt-2 font-poppins font-medium text-xs  p-6"
          layout="vertical"
          onFinishFailed={(err) => console.log(err)}
          onFinish={(changedValues) => {
            isPlot ? createPlot(changedValues) : createProperty(changedValues);
          }}
          ref={formRef}
          form={form}
        >
          <p className="text-lg font-dmsans font-semibold">Basic Information</p>
          <Divider />
          <Row className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <Col>
              <Form.Item
                label={<p className="font-normal text-sm">Title</p>}
                name="title"
                rules={[
                  { required: true, message: "Please enter Title" },
                  { min: 4, message: "Title must be at least 4 characters" },
                ]}
              >
                <Input
                  placeholder="Your Property Title"
                  type="text"
                  className="rounded-none"
                  value={title}
                  onChange={handleTitleChange}
                />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item
                label={<p className="font-normal text-sm">Slug</p>}
                name="slug"
                rules={[
                  { required: true, message: "Please enter Slug" },
                  { min: 6, message: "Slug must be at least 6 characters" },
                  {
                    pattern: /^[a-zA-Z0-9-]+$/,
                    message:
                      "Slug can only contain letters, numbers, and hyphens",
                  },
                ]}
              >
                <Input
                  placeholder="e.g.,title-slug-here"
                  value={slug}
                  onChange={(e) => setSlug(e.target.value)}
                  disabled={from === "edit" ? true : false}
                />
              </Form.Item>
            </Col>

            <Col>
              <Form.Item
                name="developerName"
                label={<p className="font-normal text-sm">Developer Name</p>}
              >
                <Input
                  placeholder="Enter Developer Name"
                  type="text"
                  className="rounded-none"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4"></Row>
          <Row className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
            <Col>
              <Form.Item
                name="projectName"
                label={<p className="font-normal text-sm">Property Name</p>}
              >
                <Input
                  placeholder="Enter Property Name"
                  type="text"
                  className="rounded-none"
                />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item
                name="propertyType"
                label={<p className="font-normal text-sm">Property Status</p>}
                rules={[
                  {
                    required: true,
                    message: "Please Select Property Status",
                  },
                ]}
              >
                <Select
                  mode="multiple"
                  suffixIcon={
                    <DownOutlined className="text-sm text-rgbaprimary9 font-normal font-dmsans" />
                  }
                  placeholder="Select Property Type"
                  value={selectedPropertyTypes}
                  onChange={(val, data) => handlePropertyTypeChange(val, data)}
                  options={propertyTypeData.map((i) => ({
                    label: i.typeName,
                    value: i.id,
                  }))}
                />
              </Form.Item>
            </Col>
            {isPlot ? (
              ""
            ) : (
              <>
                {" "}
                {leaseType.includes(true) ? (
                  <Col>
                    <Form.Item
                      name="leaseType"
                      label="Lease Type"
                      rules={[
                        {
                          required: true,
                          message: "Please Select Lease Type",
                        },
                      ]}
                    >
                      <Select
                        suffixIcon={
                          <DownOutlined className="text-sm text-rgbaprimary9 font-normal font-dmsans" />
                        }
                        placeholder=""
                        options={["Month-to-Month", "Annual", "Short-Term"].map(
                          (i) => ({
                            label: i.toString(),
                            value: i,
                          })
                        )}
                      />
                    </Form.Item>
                  </Col>
                ) : (
                  ""
                )}
                {rentType.includes(true) ? (
                  <Col>
                    <Form.Item
                      name="rentPrice"
                      label="Rent Price"
                      rules={[
                        {
                          required: true,
                          message: "Please Enter Rent Price",
                        },
                        {
                          pattern: /^[1-9]\d*(\.\d+)?$/,
                          message: "Please enter a validRent price",
                        },
                      ]}
                    >
                      <Input
                        placeholder="Enter Rent Price"
                        type="number"
                        min={0}
                        className="rounded-none"
                      />
                    </Form.Item>
                  </Col>
                ) : (
                  ""
                )}
              </>
            )}

            <Col>
              <Form.Item
                name="categoryId"
                label={<p className="font-normal text-sm">Category</p>}
                rules={[
                  {
                    required: true,
                    message: "Please Select Category ",
                  },
                ]}
              >
                <Select
                  suffixIcon={
                    <DownOutlined className="text-sm text-rgbaprimary9 font-normal font-dmsans" />
                  }
                  placeholder=""
                  options={categoryData.map((i) => ({
                    label: i.categoryName,
                    value: i.id,
                  }))}
                  onChange={(value) => handleCategoryChange(value)}
                />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item
                name="subCategoryId"
                label={<p className="font-normal text-sm">Sub Category</p>}
                rules={[
                  {
                    required: true,
                    message: "Please Select Sub Category ",
                  },
                ]}
              >
                <Select
                  suffixIcon={
                    <DownOutlined className="text-sm text-rgbaprimary9 font-normal font-dmsans" />
                  }
                  placeholder=""
                  options={subCategoryData.map((i) => ({
                    label: i.subCategoryName,
                    value: i.id,
                  }))}
                  onChange={handleSubCategoryChange}
                />
              </Form.Item>
            </Col>
            <Col>
              {" "}
              <Form.Item
                label={<p className="font-normal text-sm">Location</p>}
                name="location"
                rules={[{ required: true, message: "Location is required!" }]}
              >
                <LoadScriptNext
                  googleMapsApiKey={GOOGLE_MAPS_API_KEY}
                  libraries={libraries}
                >
                  <Autocomplete
                    onLoad={(ref) => (autocompleteRef.current = ref)}
                    onPlaceChanged={handlePlaceSelect}
                  >
                    <Input
                      value={propertylocation}
                      onChange={(e) => setLocation(e.target.value)}
                      placeholder="Enter a location"
                    />
                  </Autocomplete>
                </LoadScriptNext>
              </Form.Item>
            </Col>

            <Col>
              {" "}
              <Form.Item
                label={<p className="font-normal text-sm">State</p>}
                name="state"
                rules={[{ required: true, message: "State is required!" }]}
              >
                <Select
                  onChange={(stateName) => {
                    const selectedState = stateData.find(
                      (item) => item.name === stateName
                    ); // ✅ Find state by name
                    if (selectedState) {
                      FetchState(selectedState.id); // ✅ Send state ID to cityApi
                    }
                  }}
                  // onChange={(value, option) => handleStateChange(value, option)}
                  showSearch
                  placeholder="Select State"
                >
                  {stateData.map((item) => (
                    <Select.Option key={item.id} value={item.name}>
                      {" "}
                      {/* ✅ Use item.name as value */}
                      {item.name} {/* ✅ Display item.name */}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col>
              <Form.Item
                label={<p className="font-normal text-sm">City</p>}
                name="city"
                rules={[{ required: true, message: "City is required!" }]}
              >
                <Select showSearch placeholder="Select City">
                  {cityData.map((item) => (
                    <Option key={item.id} value={item.name}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col>
              <Form.Item
                label={<p className="font-normal text-sm">zipCode</p>}
                key="zipCode"
                name="zipCode"
                rules={[{ required: true, message: `zipCode is required!` }]}
              >
                <Input placeholder="zipCode" />
              </Form.Item>
            </Col>

            <Col>
              <Form.Item
                name="price"
                label={<p className="font-normal text-sm"> Price</p>}
                rules={[
                  {
                    required: true,
                    message: "Please Enter  Price",
                  },
                  {
                    pattern: /^[1-9]\d*(\.\d+)?$/,
                    message: "Please enter a valid price",
                  },
                ]}
              >
                <Input
                  placeholder="Enter  Price"
                  type="number"
                  min={0}
                  className="rounded-none"
                />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item
                name="priceIn"
                label={<p className="font-normal text-sm">Price In</p>}
                rules={[
                  {
                    required: true,
                    message: "Please Select  Price",
                  },
                ]}
              >
                <Select
                  suffixIcon={
                    <DownOutlined className="text-sm text-rgbaprimary9 font-normal font-dmsans" />
                  }
                  placeholder=""
                  options={[
                    { label: "Acres", value: "Acres" },
                    { label: "Sq.ft.", value: "sq.ft" },
                    { label: "Sq. Yards", value: "sq.yards" },
                  ]}
                />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item
                name="reraId"
                label={<p className="font-normal text-sm"> RERA ID</p>}
              >
                <Input placeholder="Enter  RERA ID" className="rounded-none" />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item
                name="listedBy"
                label={<p className="font-normal text-sm">Listed By</p>}
                rules={[
                  {
                    required: true,
                    message: "Please Select Listed By",
                  },
                ]}
              >
                <Select
                  suffixIcon={
                    <DownOutlined className="text-sm text-rgbaprimary9 font-normal font-dmsans" />
                  }
                  placeholder=""
                  options={["Owner", "Agent", "Builder"].map((i) => ({
                    label: i.toString(),
                    value: i,
                  }))}
                />
              </Form.Item>
            </Col>
            {isPlot ? (
              ""
            ) : (
              <Col>
                <Form.Item
                  name="availabiltyStatus"
                  label={
                    <p className="font-normal text-sm">Availabilty Status</p>
                  }
                  rules={[
                    {
                      required: true,
                      message: "Please select a Availabilty Status",
                    },
                  ]}
                >
                  <Select
                    suffixIcon={
                      <DownOutlined className="text-sm text-rgbaprimary9 font-normal font-dmsans" />
                    }
                    placeholder=""
                    options={["Ready-To-Move", "Under-Construction"].map(
                      (i) => ({ 
                        label: i.toString(),
                        value: i,
                      })
                    )}
                  />
                </Form.Item>
              </Col>
            )}

            <Col>
              <Form.Item
                name="isLuxeriousProperty"
                label={
                  <p className="font-normal text-sm">Luxurious Property</p>
                }
                rules={[
                  {
                    required: true,
                    message: "Please Select Luxurious Property Type",
                  },
                ]}
              >
                <Select
                  suffixIcon={
                    <DownOutlined className="text-sm text-rgbaprimary9 font-normal font-dmsans" />
                  }
                  placeholder=""
                  options={[
                    { label: "YES", value: true },
                    { label: "NO", value: false },
                  ]}
                />
              </Form.Item>
            </Col>

            <Col>
              <Form.Item
                name="isNegotiable"
                label={<p className="font-normal text-sm">Negotiable</p>}
                rules={[
                  {
                    required: true,
                    message: "Please Enter  Negotiable",
                  },
                ]}
              >
                <Select
                  suffixIcon={
                    <DownOutlined className="text-sm text-rgbaprimary9 font-normal font-dmsans" />
                  }
                  placeholder=""
                  options={[
                    { label: "Yes", value: true },
                    { label: "No", value: false },
                  ]}
                />
              </Form.Item>
            </Col>
            {!isPlot ? (
              <Col>
                <Form.Item
                  name="propertyAge"
                  label={<p className="font-normal text-sm">Age of Property</p>}
                  rules={[
                    {
                      required: true,
                      message: "Please Enter  Age of Property",
                    },
                  ]}
                >
                  <Select
                    suffixIcon={
                      <DownOutlined className="text-sm text-rgbaprimary9 font-normal font-dmsans" />
                    }
                    placeholder=""
                    options={[
                      { label: "New", value: "New" },
                      { label: "0-5 yrs", value: "0-5 yrs" },
                      { label: "5-10 yrs", value: "5-10 yrs" },
                      { label: "10+ yrs", value: "10+ yrs" },
                    ]}
                  />
                </Form.Item>
              </Col>
            ) : (
              ""
            )}
          </Row>
          {isPlot || isOffice || isWarehouse || isHotel ? (
            ""
          ) : (
            <>
              {" "}
              <p className="text-lg font-dmsans font-semibold">Add Price</p>
              <Divider />
              <Row className="grid grid-cols-1">
                {" "}
                <Col>
                  {" "}
                  <label className="block mb-1 font-semibold">Price Type</label>
                  <Form.List name="priceType">
                    {(fields, { add, remove }) => {
                      // Ensure one permanent field exists
                      if (fields.length === 0) {
                        add(); // Add the non-removable default item
                      }

                      return (
                        <div className="space-y-5">
                          {fields.map(({ key, name, ...restField }, index) => (
                            <Card
                              key={key}
                              className="bg-gray-50 rounded-xl border border-gray-200 shadow-sm space-y-5"
                              extra={
                                index !== 0 && (
                                  <Button
                                    type="text"
                                    icon={
                                      <MinusSquareFilled className="text-red-500" />
                                    }
                                    onClick={() => remove(index)}
                                  />
                                )
                              }
                            >
                              <Row gutter={16}>
                                <Col
                                  xs={24}
                                  sm={12}
                                  md={6}
                                  className="flex flex-col"
                                >
                                  <Form.Item
                                    {...restField}
                                    name={[name, "price"]}
                                    label={
                                      <p className="font-normal text-sm">
                                        Price
                                      </p>
                                    }
                                    rules={[{ required: false }]}
                                  >
                                    <Input
                                       type="number"
                                      placeholder="Price"
                                      className="w-full"
                                    />
                                  </Form.Item>
                                </Col>
                                <Col
                                  xs={24}
                                  sm={12}
                                  md={6}
                                  className="flex flex-col"
                                >
                                  <Form.Item
                                    {...restField}
                                    name={[name, "area"]}
                                    rules={[{ required: false }]}
                                    label={
                                      <p className="font-normal text-sm">
                                        Area(in Acres)
                                      </p>
                                    }
                                  >
                                    <Input
                                    type="number"
                                      placeholder="Area (sq ft)"
                                      className="w-full  rounded-md"
                                    />
                                  </Form.Item>
                                </Col>
                                <Col
                                  xs={24}
                                  sm={12}
                                  md={6}
                                  className="flex flex-col"
                                >
                                  <Form.Item
                                    {...restField}
                                    name={[name, "proprtyType"]}
                                    rules={[{ required: false }]}
                                    label={
                                      <p className="font-normal text-sm">
                                        Property Type
                                      </p>
                                    }
                                  >
                                    <Select
                                      placeholder="Property Type"
                                      className="w-full"
                                      options={staticPropertyTypes.map(
                                        (type) => ({
                                          value: type,
                                          label: type,
                                        })
                                      )}
                                    />
                                  </Form.Item>
                                </Col>

                                {index === 0 && (
                                  <Col
                                    xs={24}
                                    sm={12}
                                    md={6}
                                    className=" mt-[29px] justify-end"
                                  >
                                    <Button
                                      type="dashed"
                                      icon="+"
                                      onClick={() => add()}
                                      className="w-1/2 mb-2 text-[#df682c] border-[#df682c]"
                                    />
                                  </Col>
                                )}
                              </Row>
                            </Card>
                          ))}
                        </div>
                      );
                    }}
                  </Form.List>
                </Col>
              </Row>
            </>
          )}
          <p className="text-lg font-dmsans font-semibold">
            {isPlot
              ? "Plot Details"
              : isOffice
              ? "Office Details"
              : isWarehouse
              ? "Warehouse Details"
              : isHotel
              ? "Hotel/ Resorts"
              : "Property Details"}
          </p>
          <Divider />
          {isPlot ? (
            <>
              {" "}
              <Row className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 ">
                <Col>
                  <Form.Item
                    suffixIcon={
                      <DownOutlined className="text-sm text-rgbaprimary9 font-normal font-dmsans" />
                    }
                    name="boundaryWall"
                    label={<p className="font-normal text-sm">Boundary Wall</p>}
                    rules={[
                      {
                        required: true,
                        message: "Please select a Boundary Wall",
                      },
                    ]}
                  >
                    <Select
                      suffixIcon={
                        <DownOutlined className="text-sm text-rgbaprimary9 font-normal font-dmsans" />
                      }
                      placeholder="Barbed Wire "
                      options={[
                        { value: "Barbed Wire", label: "Barbed Wire" },
                        { value: "Brick Wall", label: "Brick Wall" },
                        { value: "Cemented Wall", label: "Cemented Wall" },
                      ]}
                    />
                  </Form.Item>
                </Col>
                <Col>
                  <Form.Item
                    name="gatedCommunity"
                    label={
                      <p className="font-normal text-sm"> Gated Community</p>
                    }
                    rules={[
                      {
                        required: true,
                        message: "Please Enter Gated Community",
                      },
                    ]}
                  >
                    <Select
                      suffixIcon={
                        <DownOutlined className="text-sm text-rgbaprimary9 font-normal font-dmsans" />
                      }
                      placeholder=""
                      options={[
                        { label: "YES", value: true },
                        { label: "NO", value: false },
                      ]}
                    />
                  </Form.Item>
                </Col>
                <Col>
                  <Form.Item
                    name="governmentApproval"
                    label={
                      <p className="font-normal text-sm">
                        Government Approvals
                      </p>
                    }
                    rules={[
                      {
                        required: true,
                        message: "Please Enter Government Approvals",
                      },
                    ]}
                  >
                    <Select
                      suffixIcon={
                        <DownOutlined className="text-sm text-rgbaprimary9 font-normal font-dmsans" />
                      }
                      placeholder=""
                      options={[
                        { label: "JDA", value: "jda" },
                        { label: "Society", value: "society" },
                        { label: "Others", value: "others" },
                      ]}
                    />
                  </Form.Item>
                </Col>
                <Col>
                  <Form.Item
                    name="landUseCertificate"
                    label={
                      <p className="font-normal text-sm">
                        Land Use Certification
                      </p>
                    }
                    rules={[
                      {
                        required: true,
                        message: "Please Enter Land Use Certification",
                      },
                    ]}
                  >
                    <Select
                      suffixIcon={
                        <DownOutlined className="text-sm text-rgbaprimary9 font-normal font-dmsans" />
                      }
                      placeholder=""
                      options={[
                        { label: "Yes", value: true },
                        { label: "No", value: false },
                      ]}
                    />
                  </Form.Item>
                </Col>
                <Col>
                  <Form.Item
                    suffixIcon={
                      <DownOutlined className="text-sm text-rgbaprimary9 font-normal font-dmsans" />
                    }
                    name="mainEntranceFacing"
                    label={
                      <p className="font-normal text-sm">
                        Main Entrance Facing
                      </p>
                    }
                    rules={[
                      {
                        required: true,
                        message: "Please select a Main Entrance Facing",
                      },
                    ]}
                  >
                    <Select
                      suffixIcon={
                        <DownOutlined className="text-sm text-rgbaprimary9 font-normal font-dmsans" />
                      }
                      placeholder="North"
                      options={[
                        { value: "North", label: "North" },
                        { value: "East", label: "East" },
                        { value: "West", label: "West" },
                        { value: "South", label: "South" },
                        { value: "North-East", label: "North-East" },
                        { value: "South-East", label: "South-East" },
                        { value: "North-West", label: "North-West" },
                        { value: "South-West", label: "South-West" },
                      ]}
                    />
                  </Form.Item>
                </Col>
                <Col>
                  <Form.Item
                    suffixIcon={
                      <DownOutlined className="text-sm text-rgbaprimary9 font-normal font-dmsans" />
                    }
                    name="ownershipType"
                    label={
                      <p className="font-normal text-sm">Ownership Type</p>
                    }
                    rules={[
                      {
                        required: true,
                        message: "Please select a Ownership Type",
                      },
                    ]}
                  >
                    {/* <Select
  suffixIcon={
    <DownOutlined className="text-sm text-rgbaprimary9 font-normal font-dmsans" />
  }
  placeholder="Ongoing"
  options={[
    { value: "Freehold", label: "Freehold" },
    { value: "Leasehold", label: "Leasehold" },
    {
      value: "Cooperative Society",
      label: "Cooperative Society",
    },
  ]}
/> */}
                    <Select
                      suffixIcon={
                        <DownOutlined className="text-sm text-rgbaprimary9 font-normal font-dmsans" />
                      }
                      placeholder="Select Ownership Type"
                      options={ownershipOptions.map((type) => ({
                        value: type,
                        label: type,
                      }))}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                <Col>
                  <Form.Item
                    name="waterSupply"
                    label={<p className="font-normal text-sm">Water Supply</p>}
                    rules={[
                      {
                        required: true,
                        message: "Please Select Water Supply",
                      },
                    ]}
                  >
                    <Select
                      suffixIcon={
                        <DownOutlined className="text-sm text-rgbaprimary9 font-normal font-dmsans" />
                      }
                      placeholder=""
                      options={["Municipal water", "Bore water", "NA"].map(
                        (i) => ({
                          label: i.toString(),
                          value: i,
                        })
                      )}
                    />
                  </Form.Item>
                </Col>
                <Col>
                  <Form.Item
                    name="plotArea"
                    label={
                      <p className="font-normal text-sm">Area (Sq Yards)</p>
                    }
                    rules={[
                      {
                        required: true,
                        message: "Please enter  Area",
                      },
                      {
                        pattern: /^[1-9]\d*(\.\d+)?$/,
                        message: "Please enter a valid  area",
                      },
                    ]}
                  >
                    <Input
                      placeholder="Enter  Area"
                      type="number"
                      min={0}
                      className="rounded-none"
                    />
                  </Form.Item>
                </Col>

                <Col>
                  <Form.Item
                    name="openSides"
                    label={<p className="font-normal text-sm">Open Sides</p>}
                    rules={[
                      {
                        required: true,
                        message: "Please enter number of Open Sides",
                      },
                    ]}
                  >
                    <Input
                      placeholder="Enter Open Sides"
                      type="number"
                      min={0}
                      max={4}
                      className="rounded-none"
                    />
                  </Form.Item>
                </Col>
                <Col>
                  <Form.Item
                    name="widthRoadFacing"
                    label={
                      <p className="font-normal text-sm">Width Road Facing</p>
                    }
                    rules={[
                      {
                        required: true,
                        message: "Please Enter Width Road Facing",
                      },
                      {
                        pattern: /^[0-9]+(\.[0-9]{1,2})?$/,
                        message:
                          "Enter a valid Road Width (only numbers, max 2 decimals)",
                      },
                    ]}
                  >
                    <Input
                      placeholder="Your  Width Road Facing"
                      type="number"
                      min={0}
                      className="rounded-none"
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4"></Row>
              {/* <Row className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                {" "}
                <Col>
                  <Form.Item
                    name="zoning"
                    label="Zoning"
                    rules={[
                      {
                        required: true,
                        message: "Please Enter Zoning",
                      },
                    ]}
                  >
                    <Select
                      suffixIcon={
                        <DownOutlined className="text-sm text-rgbaprimary9 font-normal font-dmsans" />
                      }
                      placeholder=""
                      options={[{ label: "Residential", value: "residential" }]}
                    />
                  </Form.Item>
                </Col>
                <Col>
                  <Form.Item
                    name="zoning"
                    label=" Drainage System"
                    rules={[
                      {
                        required: true,
                        message: "Please Enter  Drainage System",
                      },
                    ]}
                  >
                    <Select
                      suffixIcon={
                        <DownOutlined className="text-sm text-rgbaprimary9 font-normal font-dmsans" />
                      }
                      placeholder=""
                      options={[
                        { label: "Yes", value: "Yes" },
                        { label: "No", value: "No" },
                      ]}
                    />
                  </Form.Item>
                </Col>
              </Row> */}
            </>
          ) : isOffice ? (
            <Row className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
              <Col>
                <Form.Item
                  name="carpetArea"
                  label={
                    <p className="font-normal text-sm">
                      Total Land Area (Sq Yards)
                    </p>
                  }
                  rules={[
                    {
                      required: true,
                      message: "Please enter  Area",
                    },
                    {
                      pattern: /^[1-9]\d*(\.\d+)?$/,
                      message: "Please enter a valid  area",
                    },
                  ]}
                >
                  <Input
                    placeholder="Enter  Area"
                    type="number"
                    min={0}
                    className="rounded-none"
                  />
                </Form.Item>
              </Col>
              <Col>
                <Form.Item
                  name="parking"
                  label={<p className="font-normal text-sm">Parking</p>}
                  rules={[
                    {
                      required: true,
                      message: "Please Select Parking ",
                    },
                  ]}
                >
                  <Select
                    suffixIcon={
                      <DownOutlined className="text-sm text-rgbaprimary9 font-normal font-dmsans" />
                    }
                    placeholder=""
                    // defaultValue={formData.installments}

                    options={[1, 2, 3, 4, 5, 6, 7, 8, 9].map((i) => ({
                      label: i.toString(),
                      value: i,
                    }))}
                    // onChange={handleSchoolTypeChange}
                  />
                </Form.Item>
              </Col>
              <Col>
                <Form.Item
                  name="parkingAvailability"
                  label={
                    <p className="font-normal text-sm">Parking Availability</p>
                  }
                  rules={[
                    {
                      required: true,
                      message: "Please Select Parking Availability ",
                    },
                  ]}
                >
                  <Select
                    suffixIcon={
                      <DownOutlined className="text-sm text-rgbaprimary9 font-normal font-dmsans" />
                    }
                    placeholder=""
                    // defaultValue={formData.installments}

                    options={["Reserved", "Visitor Parking"].map((i) => ({
                      label: i.toString(),
                      value: i,
                    }))}
                    // onChange={handleSchoolTypeChange}
                  />
                </Form.Item>
              </Col>
              <Col>
                <Form.Item
                  name="airConditioning"
                  label={
                    <p className="font-normal text-sm">Air Conditioning</p>
                  }
                  rules={[
                    {
                      required: true,
                      message: "Please Select Air Conditioning ",
                    },
                  ]}
                >
                  <Select
                    suffixIcon={
                      <DownOutlined className="text-sm text-rgbaprimary9 font-normal font-dmsans" />
                    }
                    placeholder=""
                    // defaultValue={formData.installments}

                    options={["Central", "Split", "None"].map((i) => ({
                      label: i.toString(),
                      value: i,
                    }))}
                    // onChange={handleSchoolTypeChange}
                  />
                </Form.Item>
              </Col>
              <Col>
                <Form.Item
                  name="buildingType"
                  label={<p className="font-normal text-sm">Building Type</p>}
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Building Type",
                    },
                  ]}
                >
                  <Select
                    suffixIcon={
                      <DownOutlined className="text-sm text-rgbaprimary9 font-normal font-dmsans" />
                    }
                    placeholder=""
                    options={[
                      { label: "IT Park", value: "IT Park" },
                      {
                        label: "Commercial Building",
                        value: "Commercial Building",
                      },
                      {
                        label: "Standalone Building",
                        value: "Standalone Building",
                      },
                    ]}
                  />
                </Form.Item>
              </Col>
              {/* <Col>
                <Form.Item
                  suffixIcon={
                    <DownOutlined className="text-sm text-rgbaprimary9 font-normal font-dmsans" />
                  }
                  name="furnishing"
                  label="Furnished Status"
                  rules={[
                    {
                      required: true,
                      message: "Please select a Furnished Status",
                    },
                  ]}
                >
                  <Select
                    suffixIcon={
                      <DownOutlined className="text-sm text-rgbaprimary9 font-normal font-dmsans" />
                    }
                    placeholder="Semi Furnished"
                    options={[
                      { value: "Semi Furnished", label: "Semi Furnished" },
                      {
                        value: "Fully Furnished",
                        label: "Fully Furnished",
                      },
                      { value: "BareShell", label: "BareShell" },
                    ]}
                  />
                </Form.Item>
              </Col> */}
              <Col>
                <Form.Item
                  name="youtubeUrl"
                  label={<p className="font-normal text-sm">YouTube URL</p>}
                  rules={[
                    {
                      required: true,
                      message: "Please enter YouTube URL",
                    },
                    {
                      pattern: youtubePattern,
                      message: "Please enter a valid YouTube URL",
                    },
                  ]}
                >
                  <Input
                    placeholder="Enter YouTube URL"
                    type="text"
                    className="rounded-none"
                  />
                </Form.Item>
              </Col>

              {/* <Col>
                <Form.Item
                  name="buildingType"
                  label=" Possession Date"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter  Possession Date",
                    },
                  ]}
                >
                  <Select
                    suffixIcon={
                      <DownOutlined className="text-sm text-rgbaprimary9 font-normal font-dmsans" />
                    }
                    placeholder=""
                    options={[{ label: "IT Park", value: "IT Park" }]}
                  />
                </Form.Item>
              </Col> */}
              {/* <Col>
                <Form.Item
                  name="buildingType"
                  label=" Suitable For"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter  Suitable For",
                    },
                  ]}
                >
                  <Select
                    suffixIcon={
                      <DownOutlined className="text-sm text-rgbaprimary9 font-normal font-dmsans" />
                    }
                    placeholder=""
                    options={[{ label: "IT/ITEs", value: "IT Park" }]}
                  />
                </Form.Item>
              </Col> */}
            </Row>
          ) : isWarehouse ? (
            <>
              <Row className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                <Col>
                  <Form.Item
                    name="carpetArea"
                    label={<p className="font-normal text-sm">Area (Acres)</p>}
                    rules={[
                      {
                        required: true,
                        message: "Please enter  Area",
                      },
                      {
                        pattern: /^[1-9]\d*(\.\d+)?$/,
                        message: "Please enter a valid  area",
                      },
                    ]}
                  >
                    <Input
                      placeholder="Enter  Area"
                      type="number"
                      min={0}
                      className="rounded-none"
                    />
                  </Form.Item>
                </Col>{" "}
                <Col>
                  <Form.Item
                    name="clearHeight"
                    label={<p className="font-normal text-sm">Clear Height</p>}
                    rules={[
                      {
                        required: true,
                        message: "Please enter  Clear Height",
                      },
                      {
                        pattern: /^[1-9]\d*(\.\d+)?$/,
                        message: "Please enter a valid  Clear Height",
                      },
                    ]}
                  >
                    <Input
                      placeholder="Enter  Clear Height"
                      type="number"
                      min={0}
                      className="rounded-none"
                    />
                  </Form.Item>
                </Col>
                <Col>
                  <Form.Item
                    name="dockingBays"
                    label={<p className="font-normal text-sm">Docking Bays</p>}
                    rules={[
                      {
                        required: true,
                        message: "Please enter  Docking Bays",
                      },
                      {
                        pattern: /^[1-9]\d*(\.\d+)?$/,
                        message: "Please enter a valid  Docking Bays",
                      },
                    ]}
                  >
                    <Input
                      placeholder="Enter  Docking Bays"
                      type="number"
                      min={0}
                      className="rounded-none"
                    />
                  </Form.Item>
                </Col>
                <Col>
                  <Form.Item
                    name="warehouseType"
                    label={
                      <p className="font-normal text-sm">Warehouse Type</p>
                    }
                    rules={[
                      {
                        required: true,
                        message: "Please Select Warehouse Type",
                      },
                    ]}
                  >
                    <Select
                      suffixIcon={
                        <DownOutlined className="text-sm text-rgbaprimary9 font-normal font-dmsans" />
                      }
                      placeholder=""
                      // defaultValue={formData.installments}

                      options={[
                        "Cold Storage",
                        "Dry Storage",
                        "Industrial",
                        "Logistic Hub",
                      ].map((i) => ({
                        label: i.toString(),
                        value: i,
                      }))}
                      // onChange={handleSchoolTypeChange}
                    />
                  </Form.Item>
                </Col>
                <Col>
                  <Form.Item
                    name="parkingAvailability"
                    label={
                      <p className="font-normal text-sm">
                        Parking Availability
                      </p>
                    }
                    rules={[
                      {
                        required: true,
                        message: "Please Select Parking Availability ",
                      },
                    ]}
                  >
                    <Select
                      suffixIcon={
                        <DownOutlined className="text-sm text-rgbaprimary9 font-normal font-dmsans" />
                      }
                      placeholder=""
                      // defaultValue={formData.installments}

                      options={["Truck", "Tempo", "Staff"].map((i) => ({
                        label: i.toString(),
                        value: i,
                      }))}
                      // onChange={handleSchoolTypeChange}
                    />
                  </Form.Item>
                </Col>
                <Col>
                  <Form.Item
                    name="floorType"
                    label={<p className="font-normal text-sm">FloorType</p>}
                    rules={[
                      {
                        required: true,
                        message: "Please Select FloorType ",
                      },
                    ]}
                  >
                    <Select
                      suffixIcon={
                        <DownOutlined className="text-sm text-rgbaprimary9 font-normal font-dmsans" />
                      }
                      placeholder=""
                      // defaultValue={formData.installments}

                      options={["Concrete", "Industrial Flooring"].map((i) => ({
                        label: i.toString(),
                        value: i,
                      }))}
                      // onChange={handleSchoolTypeChange}
                    />
                  </Form.Item>
                </Col>
                <Col>
                  <Form.Item
                    name="security"
                    label={<p className="font-normal text-sm">Security</p>}
                    rules={[
                      {
                        required: true,
                        message: "Please Select Security Type ",
                      },
                    ]}
                  >
                    <Select
                      suffixIcon={
                        <DownOutlined className="text-sm text-rgbaprimary9 font-normal font-dmsans" />
                      }
                      placeholder=""
                      // defaultValue={formData.installments}

                      options={["CCTV", "Guarded Entry"].map((i) => ({
                        label: i.toString(),
                        value: i,
                      }))}
                      // onChange={handleSchoolTypeChange}
                    />
                  </Form.Item>
                </Col>
                <Col>
                  <Form.Item
                    name="fireSafetyEquipment"
                    label={
                      <p className="font-normal text-sm">
                        Fire Safety Equipment
                      </p>
                    }
                    rules={[
                      {
                        required: true,
                        message: "Please Select Fire Safety Equipment  ",
                      },
                    ]}
                  >
                    <Select
                      suffixIcon={
                        <DownOutlined className="text-sm text-rgbaprimary9 font-normal font-dmsans" />
                      }
                      placeholder=""
                      // defaultValue={formData.installments}

                      options={[
                        { label: "Yes", value: true },
                        { label: "No", value: false },
                      ]}
                      // onChange={handleSchoolTypeChange}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row className="grid grid-cols-1">
                <Col>
                  <Form.Item
                    name="youtubeUrl"
                    label={<p className="font-normal text-sm">YouTube URL</p>}
                    rules={[
                      {
                        required: true,
                        message: "Please enter YouTube URL",
                      },
                      {
                        pattern: youtubePattern,
                        message: "Please enter a valid YouTube URL",
                      },
                    ]}
                  >
                    <Input
                      placeholder="Enter YouTube URL"
                      type="text"
                      className="rounded-none"
                    />
                  </Form.Item>
                </Col>
              </Row>
            </>
          ) : isHotel ? (
            <>
              {" "}
              <Row className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                <Col>
                  <Form.Item
                    name="carpetArea"
                    label={
                      <p className="font-normal text-sm">
                        Total Land Area(Acres)
                      </p>
                    }
                    rules={[
                      {
                        required: true,
                        message: "Please enter  Area",
                      },
                      {
                        pattern: /^[1-9]\d*(\.\d+)?$/,
                        message: "Please enter a valid  area",
                      },
                    ]}
                  >
                    <Input
                      placeholder="Enter  Area"
                      type="number"
                      min={0}
                      className="rounded-none"
                    />
                  </Form.Item>
                </Col>{" "}
                <Col>
                  <Form.Item
                    name="totalRooms"
                    label={<p className="font-normal text-sm">Total Rooms</p>}
                    rules={[
                      {
                        required: true,
                        message: "Please enter Total guest rooms",
                      },
                      {
                        pattern: /^[1-9]\d*(\.\d+)?$/,
                        message: "Please enter a valid Total guest rooms",
                      },
                    ]}
                  >
                    <Input
                      placeholder="Enter Total guest rooms"
                      type="number"
                      min={0}
                      className="rounded-none"
                    />
                  </Form.Item>
                </Col>
                <Col>
                  <Form.Item
                    name="totalFloors"
                    label={<p className="font-normal text-sm">Total Floors</p>}
                    rules={[
                      {
                        required: true,
                        message: "Please enter Total Floors",
                      },
                      {
                        pattern: /^[1-9]\d*(\.\d+)?$/,
                        message: "Please enetr valid Total floors",
                      },
                    ]}
                  >
                    <Input
                      placeholder="Enter Total Floors"
                      type="number"
                      min={0}
                      className="rounded-none"
                    />
                  </Form.Item>
                </Col>
                <Col>
                  <Form.Item
                    name="parking"
                    label={<p className="font-normal text-sm">Parking</p>}
                    rules={[
                      {
                        required: true,
                        message: "Please Select Parking ",
                      },
                    ]}
                  >
                    <Select
                      suffixIcon={
                        <DownOutlined className="text-sm text-rgbaprimary9 font-normal font-dmsans" />
                      }
                      placeholder=""
                      // defaultValue={formData.installments}

                      options={[1, 2, 3, 4, 5, 6, 7, 8, 9].map((i) => ({
                        label: i.toString(),
                        value: i,
                      }))}
                      // onChange={handleSchoolTypeChange}
                    />
                  </Form.Item>
                </Col>
                <Col>
                  <Form.Item
                    name="licenses"
                    label={<p className="font-normal text-sm">Licenses</p>}
                    rules={[
                      {
                        required: true,
                        message: "Please Select Licenses ",
                      },
                    ]}
                  >
                    <Select
                      mode="tags"
                      suffixIcon={
                        <DownOutlined className="text-sm text-rgbaprimary9 font-normal font-dmsans" />
                      }
                      placeholder=""
                      // defaultValue={formData.installments}

                      options={["Fire NOC ", "FSSAI", "Tourism", "Liquor"].map(
                        (i) => ({
                          label: i.toString(),
                          value: i,
                        })
                      )}
                      // onChange={handleSchoolTypeChange}
                    />
                  </Form.Item>
                </Col>
                <Col>
                  <Form.Item
                    name="numberOfBanquetHalls"
                    label={
                      <p className="font-normal text-sm">Number Of Banquet</p>
                    }
                    rules={[
                      {
                        required: true,
                        message: "Please enter Number Of Banquet Halls",
                      },
                      {
                        pattern: /^[1-9]\d*(\.\d+)?$/,
                        message: "Please enetr valid Number Of Banquet Halls",
                      },
                    ]}
                  >
                    <Input
                      placeholder="Enter Number Of Banquet Halls"
                      type="number"
                      min={0}
                      className="rounded-none"
                    />
                  </Form.Item>
                </Col>
                <Col>
                  <Form.Item
                    name="hotelCategory"
                    label={
                      <p className="font-normal text-sm">Hotel Category</p>
                    }
                    rules={[
                      {
                        required: true,
                        message: "Please Select Hotel Category ",
                      },
                    ]}
                  >
                    <Select
                      suffixIcon={
                        <DownOutlined className="text-sm text-rgbaprimary9 font-normal font-dmsans" />
                      }
                      placeholder=""
                      // defaultValue={formData.installments}

                      options={[
                        "Budget",
                        "Boutique",
                        "Business",
                        "3 Star",
                        "4 Star",
                        "5 Star",
                      ].map((i) => ({
                        label: i.toString(),
                        value: i,
                      }))}
                      // onChange={handleSchoolTypeChange}
                    />
                  </Form.Item>
                </Col>
                <Col>
                  <Form.Item
                    name="parkingAvailability"
                    label={
                      <p className="font-normal text-sm">
                        Parking Availability
                      </p>
                    }
                    rules={[
                      {
                        required: true,
                        message: "Please Select Parking Availability ",
                      },
                    ]}
                  >
                    <Select
                      suffixIcon={
                        <DownOutlined className="text-sm text-rgbaprimary9 font-normal font-dmsans" />
                      }
                      placeholder=""
                      // defaultValue={formData.installments}

                      options={["Reserved", "Visitor Parking"].map((i) => ({
                        label: i.toString(),
                        value: i,
                      }))}
                      // onChange={handleSchoolTypeChange}
                    />
                  </Form.Item>
                </Col>
                <Col>
                  <Form.Item
                    name="airConditioning"
                    label={
                      <p className="font-normal text-sm">Air Conditioning</p>
                    }
                    rules={[
                      {
                        required: true,
                        message: "Please Select Air Conditioning ",
                      },
                    ]}
                  >
                    <Select
                      suffixIcon={
                        <DownOutlined className="text-sm text-rgbaprimary9 font-normal font-dmsans" />
                      }
                      placeholder=""
                      // defaultValue={formData.installments}

                      options={["Central", "Split", "None"].map((i) => ({
                        label: i.toString(),
                        value: i,
                      }))}
                      // onChange={handleSchoolTypeChange}
                    />
                  </Form.Item>
                </Col>
                <Col>
                  <Form.Item
                    name="youtubeUrl"
                    label={<p className="font-normal text-sm">YouTube URL</p>}
                    rules={[
                      {
                        required: true,
                        message: "Please enter YouTube URL",
                      },
                      {
                        pattern: youtubePattern,
                        message: "Please enter a valid YouTube URL",
                      },
                    ]}
                  >
                    <Input
                      placeholder="Enter YouTube URL"
                      type="text"
                      className="rounded-none"
                    />
                  </Form.Item>
                </Col>
              </Row>
            </>
          ) : (
            <>
              {" "}
              <Row className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                {" "}
                <Col>
                  <Form.Item
                    name="carpetArea"
                    label={<p className="font-normal text-sm">Carpet Area</p>}
                    rules={[
                      {
                        required: true,
                        message: "Please enter Carpet Area",
                      },
                      {
                        pattern: /^[1-9]\d*(\.\d+)?$/,
                        message: "Please enter a valid carpet area",
                      },
                    ]}
                  >
                    <Input
                      placeholder="Enter Carpet Area"
                      type="number"
                      min={0}
                      className="rounded-none"
                    />
                  </Form.Item>
                </Col>
                <Col>
                  <Form.Item
                    name="plotArea"
                    label={<p className="font-normal text-sm"> Area</p>}
                    rules={[
                      {
                        required: true,
                        message: "Please enter  Area",
                      },
                      {
                        pattern: /^[1-9]\d*(\.\d+)?$/,
                        message: "Please enter a valid  area",
                      },
                    ]}
                  >
                    <Input
                      placeholder="Enter  Area"
                      type="number"
                      min={0}
                      className="rounded-none"
                    />
                  </Form.Item>
                </Col>
                <Col>
                  <Form.Item
                    name="bedrooms"
                    label={<p className="font-normal text-sm">Bedrooms</p>}
                    rules={[
                      {
                        required: true,
                        message: "Please enter Bedrooms",
                      },
                      {
                        pattern: /^[1-9]\d*(\.\d+)?$/,
                        message: "Please enter a valid number of Bedrooms",
                      },
                    ]}
                  >
                    <Input
                      placeholder="Enter Bedrooms"
                      type="number"
                      min={0}
                      className="rounded-none"
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                <Col>
                  <Form.Item
                    name="bathrooms"
                    label={<p className="font-normal text-sm">Bathrooms</p>}
                    rules={[
                      {
                        required: true,
                        message: "Please enter Bathrooms",
                      },
                      {
                        pattern: /^[1-9]\d*(\.\d+)?$/,
                        message: "Please enter a valid number of Bathrooms",
                      },
                    ]}
                  >
                    <Input
                      placeholder="Enter Bathrooms"
                      type="number"
                      min={0}
                      className="rounded-none"
                    />
                  </Form.Item>
                </Col>
                <Col>
                  <Form.Item
                    name="totalFloors"
                    label={<p className="font-normal text-sm">Total Floors</p>}
                    rules={[
                      {
                        required: true,
                        message: "Please enter Total Floors",
                      },
                      {
                        pattern: /^[1-9]\d*(\.\d+)?$/,
                        message: "Please enetr valid Total floors",
                      },
                    ]}
                  >
                    <Input
                      placeholder="Enter Total Floors"
                      type="number"
                      min={0}
                      className="rounded-none"
                    />
                  </Form.Item>
                </Col>
                <Col>
                  <Form.Item
                    name="floorNo"
                    label={<p className="font-normal text-sm">Floor No</p>}
                    rules={[
                      {
                        required: true,
                        message: "Please enter Floor No",
                      },
                      {
                        pattern: /^[1-9]\d*(\.\d+)?$/,
                        message: "Please enter a valid Floor Number",
                      },
                    ]}
                  >
                    <Input
                      placeholder="Enter Floor No"
                      type="number"
                      min={0}
                      className="rounded-none"
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                <Col>
                  <Form.Item
                    name="balconies"
                    label={<p className="font-normal text-sm">Balconies</p>}
                    rules={[
                      {
                        required: true,
                        message: "Please enter Balconies",
                      },
                      {
                        pattern: /^[1-9]\d*(\.\d+)?$/,
                        message: "Please enter a valid number of Balconies",
                      },
                    ]}
                  >
                    <Input
                      placeholder="Enter Balconies"
                      type="number"
                      min={0}
                      className="rounded-none"
                    />
                  </Form.Item>
                </Col>
                <Col>
                  <Form.Item
                    name="parking"
                    label={<p className="font-normal text-sm">Parking</p>}
                    rules={[
                      {
                        required: true,
                        message: "Please Select Parking ",
                      },
                    ]}
                  >
                    <Select
                      suffixIcon={
                        <DownOutlined className="text-sm text-rgbaprimary9 font-normal font-dmsans" />
                      }
                      placeholder=""
                      // defaultValue={formData.installments}

                      options={[1, 2, 3, 4, 5, 6, 7, 8, 9].map((i) => ({
                        label: i.toString(),
                        value: i,
                      }))}
                      // onChange={handleSchoolTypeChange}
                    />
                  </Form.Item>
                </Col>
                <Col>
                  <Form.Item
                    suffixIcon={
                      <DownOutlined className="text-sm text-rgbaprimary9 font-normal font-dmsans" />
                    }
                    name="furnishing"
                    label={
                      <p className="font-normal text-sm">Furnished Status</p>
                    }
                    rules={[
                      {
                        required: true,
                        message: "Please select a Furnished Status",
                      },
                    ]}
                  >
                    <Select
                      suffixIcon={
                        <DownOutlined className="text-sm text-rgbaprimary9 font-normal font-dmsans" />
                      }
                      placeholder="Semi Furnished"
                      options={[
                        { value: "Semi Furnished", label: "Semi Furnished" },
                        {
                          value: "Fully Furnished",
                          label: "Fully Furnished",
                        },
                        { value: "Unfurnished", label: "Unfurnished" },
                      ]}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row className="grid grid-cols-1">
                <Col>
                  <Form.Item
                    name="youtubeUrl"
                    label={<p className="font-normal text-sm">YouTube URL</p>}
                    rules={[
                      {
                        required: true,
                        message: "Please enter YouTube URL",
                      },
                      {
                        pattern: youtubePattern,
                        message: "Please enter a valid YouTube URL",
                      },
                    ]}
                  >
                    <Input
                      placeholder="Enter YouTube URL"
                      type="text"
                      className="rounded-none"
                    />
                  </Form.Item>
                </Col>
              </Row>
            </>
          )}
          {isPlot ? (
            ""
          ) : (
            <Row className="grid grid-cols-1">
              <Col>
                <Form.Item
                  name="brochure"
                  label={
                    <div className="flex">
                      <p className="font-normal text-sm">Brochure</p>{" "}
                      <p className="text-sm text-red-500 font-normal">
                        (Max size 20MB)
                      </p>
                    </div>
                  }
                >
                  <Upload
                    accept=".pdf"
                    listType="picture"
                    beforeUpload={beforeUpload}
                    onChange={handleUploadChange}
                    onRemove={handleRemoveBrochure}
                    customRequest={customRequest}
                    fileList={
                      brochure ? [{ uid: "-1", name: brochure.name }] : []
                    }
                  >
                    {!brochure && (
                      <Button icon={<MdUpload />}>
                        Upload Property Document (PDF)
                      </Button>
                    )}
                  </Upload>
                </Form.Item>
              </Col>{" "}
            </Row>
          )}
          <Row className="grid grid-cols-1">
            {" "}
            <Col>
              <Form.Item
                label={<p className="font-normal text-sm">Near By Landmarks</p>}
                name="nearbyLandmarks"
                rules={[
                  { required: true, message: "Enter at least one nearby area" },
                ]}
              >
                <Select
                  mode="tags"
                  placeholder="Enter areas like school, hospital, park..."
                  tokenSeparators={[","]}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row className="grid grid-cols-1">
            <Col>
              <Form.Item
                name="description"
                label={<p className="font-normal text-sm">Description</p>}
                rules={[
                  {
                    required: true,
                    message: "Please Enter Description",
                  },
                ]}
              >
                <ReactQuill
                  theme="snow"
                  className="bg-white"
                  onChange={(value) =>
                    form.setFieldsValue({ description: value })
                  }
                  placeholder="Write your product description here..."
                />
              </Form.Item>
            </Col>
          </Row>
          <p className="text-lg font-dmsans font-semibold">
            Upload Property Images
          </p>
          <Divider />{" "}
          <Row gutter={8} className="grid grid-cols-1  gap-4">
            <Col>
              <Form.Item name="files">
                <Upload
                  {...props}
                  listType="picture"
                  fileList={updatedList}
                  multiple
                  // onChange={handleUploadChange}
                  onRemove={(file) => handleRemove(file)}
                >
                  <Button icon={<MdUpload />}>Click to Upload</Button>
                </Upload>
              </Form.Item>
            </Col>

            {from === "edit" ? (
              <Col>
                <Form.Item
                  name="thumbnail"
                  label={<p className="font-normal text-sm">Set Thumbnail</p>}
                >
                  <div>
                    {fileLists.map((file) => (
                      <div
                        key={file.uid}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginBottom: "10px",
                        }}
                      >
                        <Checkbox
                          checked={selectedThumbnail === file.uid}
                          onChange={() => handleThumbnailChange(file)}
                        >
                          Set as Thumbnail
                        </Checkbox>

                        <Image
                          src={file.url}
                          alt={file.name}
                          style={{ width: "30px", marginLeft: "10px" }}
                        />

                        <Button
                          danger
                          type="link"
                          onClick={() => handleRemove(file)}
                          style={{ marginLeft: "10px" }}
                        >
                          <DeleteOutlined />
                        </Button>
                      </div>
                    ))}
                  </div>
                </Form.Item>
              </Col>
            ) : (
              ""
            )}
          </Row>
          <p className="text-lg font-dmsans font-semibold">
            {isPlot ? "Site Plan" : "Floor Plan"}
          </p>
          <Divider />
          <Form.List name="floorPlanType">
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ key, name, fieldKey, ...restField }, index) => (
                  <Card
                    key={key}
                    className="mb-4 bg-gray-100 shadow-sm"
                    extra={
                      <Button
                        type="text"
                        icon={<DeleteOutlined className="text-red-500" />}
                        onClick={() => remove(name)}
                      />
                    }
                  >
                    {" "}
                    <Row gutter={[16, 16]} className="flex flex-wrap">
                      <Col xs={24} sm={12} md={6} className="flex flex-col">
                        <Form.Item
                          {...restField}
                          name={[name, "title"]}
                          fieldKey={[fieldKey, "title"]}
                          label={<p className="font-normal text-sm">Title</p>}
                          className="w-full"
                          rules={[{ required: false }]} // explicitly optional
                        >
                          <Input placeholder="Enter Title" />
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={12} md={6} className="flex flex-col">
                        <Form.Item
                          {...restField}
                          name={[name, "area"]}
                          fieldKey={[fieldKey, "area"]}
                          rules={[{ required: false }]}
                          label={
                            <p className="font-normal text-sm">
                              Area(in sq. ft)
                            </p>
                          }
                          className="w-full"
                        >
                          <Input type="number" placeholder="e.g. 500" />
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={12} md={6} className="flex flex-col">
                        <Form.Item
                          {...restField}
                          name={[name, "floorPlanImagePath"]}
                          fieldKey={[fieldKey, "floorPlanImagePath"]}
                          rules={[{ required: false }]}
                          label={
                            <p className="font-normal text-sm">Upload Image</p>
                          }
                        >
                          {from === "edit" &&
                          propertyData?.floorPlans?.[index]
                            ?.floorPlanImagePath ? (
                            <div className="flex flex-col">
                              <Image
                                src={`${process.env.REACT_APP_IMAGE_URL}${propertyData.floorPlans[index].floorPlanImagePath}`}
                                alt="Floor Plan"
                                width={100}
                                height={100}
                              />
                            </div>
                          ) : (
                            <Upload
                              accept=".jpg,.jpeg,.png,.pdf"
                              multiple={false}
                              listType="picture"
                              beforeUpload={(file) =>
                                handleBeforeUpload(file, index)
                              }
                              fileList={floorPlanImages[index] || []}
                              onRemove={() => handleRemoveFloorPlan(index)}
                            >
                              {!floorPlanImages[index]?.length && (
                                <Button icon={<MdUpload />}>
                                  Upload {isPlot ? "Site Plan" : "Floor Plan "}
                                </Button>
                              )}
                            </Upload>
                          )}
                        </Form.Item>
                      </Col>

                      {/* <Col>
                      {fields.length > 1 && (
                        <MinusCircleOutlined
                          onClick={() => {
                            remove(name);
                            setFloorPlanImages((prev) => {
                              const updatedImages = { ...prev };
                              const newImages = Object.keys(updatedImages)
                                .filter((key) => Number(key) !== index)
                                .reduce((acc, key, i) => {
                                  acc[i] = updatedImages[key];
                                  return acc;
                                }, {});
                              return newImages;
                            });
                          }}
                          style={{ color: "red" }}
                        />
                      )}
                    </Col> */}
                    </Row>
                  </Card>
                ))}

                <Button
                  type="dashed"
                  onClick={() => add()}
                  block
                  icon={<PlusOutlined />}
                  className="mt-4"
                >
                  {isPlot ? "Add Site Plan" : "Add Floor Plan Type"}
                </Button>
              </>
            )}
          </Form.List>
          <p className="text-lg font-dmsans font-semibold mt-4">Amenities</p>
          <Divider />
          <Row className="grid grid-cols-1">
            <Col>
              <Form.Item
                name="amenities"
                rules={[
                  {
                    required: true,
                    message: "Please Select Amenities",
                  },
                ]}
              >
                <Checkbox.Group
                  value={selectedAmenities}
                  onChange={handleAmenityChange}
                >
                  <div className="gap-4  grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6">
                    {amenitiesData.map((i) => (
                      <div
                        // style={gridStyle}
                        className="border border-gray-200  rounded-md p-2 h-20 text-left"
                      >
                        <Checkbox
                          key={i.id}
                          value={i.id}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 8,
                          }}
                        >
                          <Image
                            preview={false}
                            width={20}
                            height={20}
                            src={`${process.env.REACT_APP_IMAGE_URL}${i.iconImagePath}`}
                          />
                          <p className="font-normal text-sm">{i.name}</p>
                        </Checkbox>
                      </div>
                    ))}
                  </div>
                </Checkbox.Group>
              </Form.Item>
            </Col>
          </Row>
          <Row className="flex justify-between max-w-[96%]">
            <Form.Item>
              <Button
                className="rounded-none p-[0px_32px_0px_32px]   text-sm font-dmsans font-semibold text-gray2 "
                size="large"
                htmlType="onSubmit"
                // onClick={() => setActiveTab("1")}
              >
                Cancel
              </Button>
            </Form.Item>

            <Form.Item>
              <Button
                loading={isLoading}
                className="rounded-none p-[0px_32px_0px_32px]  text-white font-dmsans font-semibold  bg-rgbaprimary9 text-xs "
                size="large"
                htmlType="submit"
              >
                {from === "edit" ? "Save" : "Create"}
              </Button>
            </Form.Item>
          </Row>
        </Form>
      </div>
    </div>
  );
}
export default CreateProperty;
